module.exports = __webpack_public_path__ + "static/img/10.215ea44.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/2/zh/10.png
// module id = 0otv
// module chunks = 0